import { lazy, Suspense } from 'react';
import { IconArrowLeft } from '@picsart/design-system/foundation/icons/IconArrowLeft';
import { useResultOverlayStyles } from './styles';

const Loading = lazy(() => import('@/components/Loading'));

interface ResultOverlayProps {
  onClose: () => void;
}

export const ResultOverlay = ({ onClose }: ResultOverlayProps) => {
  const classes = useResultOverlayStyles();

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') onClose();
  };

  return (
    <div className={classes.fullScreenOverlay}>
      <div
        className={classes.overlayHeader}
        onClick={onClose}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
      >
        <IconArrowLeft fill="currentColor" className={classes.backIcon} />
        Generating...
      </div>
      <div className={classes.overlayContent}>
        <Suspense fallback={null}>
          <Loading />
        </Suspense>
      </div>
    </div>
  );
};
